import React, { useState } from "react";
import Moment from "react-moment";
import { Badge } from "reactstrap";
import StagesForm from "../stage/Form";
import StageView from "../stage/View";

const ApplicantStages = (props) => {
  const {
    postulationState,
    postulatedAt,
    stages,
    workFlow,
    applicant,
    courseId,
    postulationId,
    setApplicanttHit,
    updateHit,
    boardRef,
    showNotification,
    reloadQuery,
    isAdmin,
    currentUserRole
  } = props;

  const [selectedStage, setSelectedStage] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const getOrderedStages = () => {
    if(!Array.isArray(stages)){
      return [];
    }
    return workFlow
      .map((step) => stages.find((s) => s.stage_type === step.type))
      .filter(Boolean);
  };

  const drawIconState = (aasmState) => {
    let icon,
      color,
      title = "";
    switch (aasmState) {
      case "pending":
        icon = "far fa-clock text-white";
        color = "warning";
        title = "Pendiente";
        break;
      case "approved":
        icon = "fas fa-check";
        color = "success";
        title = "Aprobado";
        break;
      case "rejected":
        icon = "fas fa-times";
        color = "danger";
        title = "Rechazado";
        break;
      default:
        icon = "fas fa-circle";
        color = "secondary";
        title = "No iniciado";
        break;
    }

    return (
      <Badge color={color}>
        <i aria-hidden="true" className={icon} title={title}></i>
      </Badge>
    );
  };

  const countUploadedDocs = (stage) => {
    if (!stage || !Array.isArray(stage.requested_documents)) return 0;
      return stage.requested_documents.filter((d) => d?.uploaded).length;
    };

    const DocsIcon = ({ stage }) => {
    const uploaded = countUploadedDocs(stage);
    if (uploaded <= 0) return null;
    const title = uploaded === 1 ? "1 documento adjunto" : `${uploaded} documentos adjuntos`;
    return (
      <span
        className="ms-1"
        title={title}
        aria-label={title}
      >
        <i className="fas fa-paperclip text-secondary" aria-hidden="true"></i>
      </span>
    );
  };

  const handleEditStage = (stage) => {
    if (!isAdmin) return;
    setSelectedStage(stage);
    setEditMode(true);
  };

  const handleCloseModal = () => {
    setSelectedStage(null);
    setEditMode(false);
  };

  const orderedStages = getOrderedStages();

  return (
    <div className="my-2 my-lg-0">
      <small className="fw-bold">Etapas del candidato</small>
      <ul className="fa-ul list-unstyled ms-1 small text-muted">
        <li>
          {drawIconState(postulationState)}
          Postulación&nbsp;
          <small className="text-muted">
            <Moment format="DD/MM/YYYY HH:mm">{postulatedAt}</Moment>
          </small>
        </li>

        {orderedStages.map((stage, index) => (
          <li key={index}>
            {drawIconState(stage.aasm_state)}
            {stage.aasm_state === "pending" && !(
              Array.isArray(currentUserRole)
                ? currentUserRole.includes("job_head")
                : currentUserRole === "job_head"
            ) ? (
              <StagesForm
                stage={stage}
                applicant={applicant}
                courseId={courseId}
                postulationId={postulationId}
                setApplicanttHit={setApplicanttHit}
                updateHit={updateHit}
                boardRef={boardRef}
                showNotification={showNotification}
                reloadQuery={reloadQuery}
              />
            ) : (stage.aasm_state === "approved" || stage.aasm_state === "rejected") ? (
              <StageView stage={stage} applicant={applicant} />
            ) : (
              stage.name || "Sin nombre"
            )}<DocsIcon stage={stage} />{" "}

            {stage.created_at && (
              <small className="text-muted">
                <Moment format="DD/MM/YYYY HH:mm">{stage.created_at}</Moment>
              </small>
            )}
            {isAdmin && stage.aasm_state !== "pending" && (
              <small
                style={{
                  marginLeft: "8px",
                  cursor: "pointer",
                  color: "#007bff",
                  textDecoration: "underline",
                  fontSize: "12px"
                }}
                onClick={() => handleEditStage(stage)}
              >
                Editar
              </small>
            )}
          </li>
        ))}
      </ul>

      {editMode && selectedStage && isAdmin &&(
        <StagesForm
          stage={selectedStage}
          applicant={applicant}
          courseId={courseId}
          postulationId={postulationId}
          setApplicanttHit={setApplicanttHit}
          updateHit={updateHit}
          boardRef={boardRef}
          showNotification={showNotification}
          isEditing={true}
          toggleModal={handleCloseModal}
          reloadQuery={reloadQuery}
        />
      )}
    </div>
  );
};

export default ApplicantStages;
